import { useAtom } from "jotai";
import Icon from "../../commons/Icon";
import { useCallback, useEffect, useRef, useState } from "react";
import { s } from "../../../lib/styler";
import { serviceSync } from "../../../services/sync.service";

export type MessagingHeaderNetworkStatusProps = {
}

export default function MessagingHeaderNetworkStatus({ }: MessagingHeaderNetworkStatusProps) {
    const [online, setOnline] = useAtom(serviceSync.atomNetworkStatusOnline);
    const [forceHide, setForceHide] = useState(false);

    const [show, setShow] = useState(false);
    const [showOnline, setShowOnline] = useState(false);

    const timeoutHandleRef = useRef(0);

    useEffect(() => {
        const resetTimeout = () => {
            clearTimeout(timeoutHandleRef.current);
            timeoutHandleRef.current = 0;
        };
        if (!online) {
            resetTimeout();
            setShowOnline(false);
            setShow(true);
            setForceHide(false);
        }
        else if (show && !showOnline) {
            resetTimeout();
            setShowOnline(true);
            setShow(true);
            setForceHide(false);
            timeoutHandleRef.current = setTimeout(() => {
                setShow(false);
            }, 3000);
        }
    }, [online, show, showOnline]);

    const closeClickHandler = useCallback(() => {
        setForceHide(true);
    }, []);

    const effectiveShow = show && !forceHide;

    return (
        <div className={s("absolute bottom-0 left-0 right-0 flex justify-center pb-[30px] transition-opacity duration-300", {}, [
            ["opacity-100 pointer-events-auto", "opacity-0 pointer-events-none", effectiveShow],
        ])}>
            <div className={s(`bg-gray-700/90 px-[25px] py-[10px] rounded-[10px] font-bold flex items-center gap-[7px]`, {}, [
                ["text-green-500", "text-red-400", showOnline]
            ])}>
                <Icon className="relative top-[2px]" name={showOnline ? "bxs-circle" : "bx-circle"} size="20px" />
                {showOnline && "You Are Online"}
                {!showOnline && "You Are Offline"}
                <Icon
                    className="cursor-pointer duration-200 transition-colors relative top-[2px] left-[10px] text-gray-400 hover:text-gray-300" name={"bx-x"} size="30px"
                    onClick={closeClickHandler}
                />
            </div>
        </div>
    );
}